<template>
  <div class="MerchantSettled">
    <div class=" MerchantSettled_box">
      <!-- <div class="MerchantSettled_title">入驻申请</div> -->
      <div style="margin: 0 auto;">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" class="demo-ruleForm">
          <div class="littleTitleBox">
            <div class="littleTitle_text">商家信息登记</div>
            <div class="littleTitle_line"></div>
          </div>
          <div class="infoBox">
            <el-form-item label="入驻类型" prop="type" class="infoItem">
              <el-select v-model="ruleForm.type" placeholder="请选择企业类型" style="width: 100%" disabled>
                <!-- <el-option label="个人" :value="1"></el-option> -->
                <el-option label="企事业单位" :value="2"></el-option>
                <el-option label="政府" :value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="ruleForm.type==2?'企业名称':'机构名称'" prop="name" class="infoItem">
              <el-input v-model="ruleForm.name" :placeholder="ruleForm.type==2?'请输入企业名称':'请输入机构名称'" style="width: 100%"></el-input>
            </el-form-item>
            <el-form-item :label="ruleForm.type==2?'企业地址':'机构地址'" prop="address" class="infoItem">
              <el-input v-model="ruleForm.address" :placeholder="ruleForm.type==2?'请输入企业地址':'请输入机构地址'" style="width: 100%"></el-input>
            </el-form-item>
            <el-form-item v-if="ruleForm.type==2" label="注册资金(万)" prop="registeredCapital" class="infoItem">
              <el-input-number v-model="ruleForm.registeredCapital" placeholder="请输入注册资金" id="phone" :controls="false" style="width: 100%"></el-input-number>
            </el-form-item>
            <el-form-item v-if="ruleForm.type==2" label="法人姓名" prop="legalPerson" class="infoItem">
              <el-input v-model="ruleForm.legalPerson" placeholder="请输入法人姓名" style="width: 100%"></el-input>
            </el-form-item>
            <el-form-item :label="ruleForm.type==2?'社会信用代码':'机构码'" prop="creditCode" class="infoItem">
              <el-input v-model="ruleForm.creditCode" :placeholder="ruleForm.type==2?'请输入统一社会信用代码':'请输入机构码'" style="width: 100%"></el-input>
            </el-form-item>
            <el-form-item v-if="ruleForm.type==2" label="法人身份证号" prop="idCard" class="infoItem" required>
              <el-input v-model="ruleForm.idCard" placeholder="请输入法人身份证号" style="width: 100%"></el-input>
            </el-form-item>
            <el-form-item label="所在地" class="infoItem">
              <citySingle @getCityInfo="getCityInfoFun" :sendCityInfo="[ruleForm.countryName,ruleForm.provinceName,ruleForm.cityName,ruleForm.countyName]"></citySingle>
            </el-form-item>
          </div>

          <div class="littleTitleBox">
            <div class="littleTitle_text">介绍及经营范围</div>
            <div class="littleTitle_line"></div>
          </div>
          <el-form-item label="单位介绍" prop="introduction">
            <el-input type="textarea" v-model="ruleForm.introduce" style="width: 80%" rows="1" placeholder="请输入单位介绍"></el-input>
          </el-form-item>
          <el-form-item label="经营范围" prop="businessScope">
            <el-input type="textarea" v-model="ruleForm.businessScope" rows="1" placeholder="请输入经营范围" style="width: 80%"></el-input>
          </el-form-item>
          <div class="littleTitleBox">
            <div class="littleTitle_text">上传营业执照或其他证明扫描件</div>
            <div class="littleTitle_line"></div>
          </div>
          <div style="padding:0 130px;">
            <el-upload class="upload-demo" list-type="picture-card" :action="this.$const.common.fileUpload" style="margin-bottom:20px;width:51%;" :on-change="upLoadFileChange" :on-success="handleAvatarSuccess" :on-remove="handleRemove" :before-remove="beforeRemove" multiple :limit="3" :on-exceed="handleExceed" :file-list="fileList">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">
                点击文件进行上传，支持pdf 与jpg格式文件
              </div>
            </el-upload>
          </div>
          <div class="littleTitleBox">
            <div class="littleTitle_text">店铺负责人信息</div>
            <div class="littleTitle_line"></div>
          </div>
          <div class="infoBox">
            <el-form-item label="负责人姓名" prop="headManName">
              <el-input v-model="ruleForm.headManName" placeholder="请输入负责人姓名"></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="contactNumber">
              <el-input type="number" v-model="ruleForm.contactNumber" placeholder="请输入联系电话"></el-input>
            </el-form-item>
            <!-- <el-form-item label="" prop="allowing">
            <el-checkbox-group v-model="ruleForm.allowing">
              <el-checkbox>
                我已阅读并同意
                <el-button type="text" @click.stop="readAgreement">
                  《商业遥感大数据平台服务协议》</el-button>
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>-->
          </div>
          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')">立即提交</el-button>
            <el-button @click="resetForm('ruleForm')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  import { regionDataPlus } from "element-china-area-data";

  import IdentityCodeValid from "@/utils/checkIdent";

  import citySingle from "@/components/citySingle.vue";

  export default {
    components: {
      citySingle
    },
    props: ['ruleForm'],
    data() {
      var checkIdcard = (rule, value, callback) => {
        let data = value.toUpperCase(); //转换成大写
        if (!IdentityCodeValid(data)) {
          return callback(new Error("请输入正确的身份证号码"));
        } else {
          return callback();
        }
      };
      var checkAllowing = (rule, value, callback) => {
        if (!value) {
          return callback(new Error("请同意相关条款"));
        } else {
          return callback();
        }
      };
      return {
        fileList: [],
        options: regionDataPlus,
        // ruleForm: {
        //   "address": "", //	企业地址
        //   // "applyNumber": "", //	申请编号HTYGRZ+YYYYmmdd
        //   // "applyTime": "", //	申请时间
        //   // "applyUserId": "", //申请人用户id
        //   "businessScope": "", //经营范围
        //   "certificationUrl": "", //	资质资源链接；多个以英文“;”隔开
        //   // "checkResultNotice": "", //审核结果信息，未通过，需要填写原因
        //   // "checkTime": "", //审核时间
        //   // "checkUserId": "", //审核用户id，后台管理用户
        //   "cityId": 0, //市id
        //   "contactNumber": "", //负责人电话
        //   "countyId": 0, //县id
        //   "creditCode": "", //	统一社会信用代码
        //   "headManName": "", //负责人姓名
        //   // "id": "", //主键
        //   "idCard": "", //法人身份证号
        //   "introduce": "", //介绍
        //   "legalPerson": "", //法人姓名
        //   "name": "", //企业名称
        //   "provinceId": 0, //省id
        //   "registeredCapital": '', //注册资金
        //   "status": 0, //审核状态：0：默认，未审核；1：审核通过；2：审核不通过 3：冻结（审核通过）
        //   "type": 1, //	企业类型：商家类型：1.个人；2.企事业单位；	3.政府
        //   "Location": '', //所在地 前端用
        //   allowing: false,
        // },
        rules: {
          name: [{ required: true, message: "请输入名称", trigger: "blur" }],
          address: [{ required: true, message: "请输入地址", trigger: "blur" }],
          type: [
            { required: true, message: "请选择入驻类型", trigger: "change" },
          ],
          legalPerson: [
            { required: true, message: "请输入法人姓名", trigger: "change" },
          ],
          // address: [{ required: true, message: "请选择所在地", trigger: "blur" }],
          headManName: [
            { required: true, message: "请输入负责人姓名", trigger: "blur" },
          ],
          contactNumber: [{ required: true, message: "请输入联系电话", trigger: "blur" }],
          creditCode: [{
            required: true,
            message: "请输入相关信息码",
            trigger: "blur",
          }, ],
          registeredCapital: [{ required: true, message: "请输入注册资金", trigger: "blur" }],
          allowing: [{ validator: checkAllowing, trigger: "blur" }],
          idCard: [{ validator: checkIdcard, trigger: "blur" }],
        },
      };
    },
    mounted() {
      this.ruleForm.certificationUrlList.forEach((item, i) => {
        this.fileList.push({ name: item, url: item })
      })
      console.log(this.fileList, 123)
      // this.fileList = [{ name: 'food.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100' }, { name: 'food2.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100' }]
      // console.log(this.$store.state.user.userInfo.registerIdentity, this.$router);
      // if (this.$store.state.user.userInfo.registerIdentity && this.$store.state.user.userInfo.registerIdentity != 1) {
      //   this.ruleForm.type = this.$store.state.user.userInfo.registerIdentity;
      //   this.ruleForm.name = this.$store.state.user.userInfo.companyName || this.$store.state.user.userInfo.organizationName || userName;
      //   this.ruleForm.creditCode = this.$store.state.user.userInfo.companyLicenseCode || this.$store.state.user.userInfo.organizationCode;

      // } else {
      //   this.ruleForm.type = 2
      //   // this.$message.warning('当前账号暂支持入驻');
      //   // var that = this;
      //   // setTimeout(function() {
      //   //   that.$router.go(-1)
      //   // }, 3000)
      // }

    },
    methods: {
      // 获取省市区信息
      getCityInfoFun(value) {
        // this.ruleForm.address = value.11
        console.log('获取省市区信息', value);
        
        this.ruleForm.countryId = value[0];
        this.ruleForm.provinceId = value[1];
        this.ruleForm.cityId = value[2];
        this.ruleForm.countyId = value[3];
      },
      // 文件上传操作按钮
      handleRemove(file, fileList) {
        console.log(file, fileList);
        this.fileList = fileList;
      },
      handleAvatarSuccess(res, file) {
        console.log(res, file);
        this.fileList.push({ name: res.data, url: res.data })
      },
      upLoadFileChange(file, fileList) {
        // console.log(file, fileList, this.fileList);
        // // this.fileList = fileList;
        // fileList.forEach((item, i) => {
        //   this.fileList[i] = { name: item.response.data, url: item.response.data }
        // })
      },
      handleExceed(files, fileList) {
        this.$message.warning(
          `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
        );
      },
      beforeRemove(file) {
        return this.$confirm(`确定移除 ${file.name}？`);
      },
      // 协议跳转
      readAgreement() {
        console.log("打开协议页面");
      },
      change(e) {
        console.log(e);
      },
      submitForm(formName) {
        console.log(this.fileList)
        // return false;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            console.log(this.ruleForm);
            if (this.fileList) {
              this.ruleForm.certificationUrl = "";
              this.fileList.forEach((item, i) => {
                this.ruleForm.certificationUrl = this.ruleForm.certificationUrl + item.url + ';'
              })
            }
            delete this.ruleForm.certificationUrlList;
            this.$http.put(this.$const.RemoteSensingMall.editSupplierupdate, this.ruleForm, true).then((res) => {
              this.$message.success('提交商家信息成功');
              this.$emit('changePhoneSuccess')
            }).catch((error) => {
              console.log(error, 'error')
            });
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .MerchantSettled_box {
    padding: 20px;
    background: #fff;
    box-shadow: 0px 0px 5px #ccc;
    height: 75vh;
    overflow: auto;
  }

  .infoItem {
    width: 33%;
    margin-bottom: 10px !important;
  }

  .el-form-item {
    margin-bottom: 10px;
  }

  .infoBox {
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    align-items: center;
  }

  .littleTitle_line {
    flex: 1;
    border-bottom: 2px solid #ccc;
    height: 30px;
    line-height: 30px;
  }

  .littleTitle_text {
    color: #1890ff;
    height: 30px;
    line-height: 30px;
    padding: 0 20px;
    border-bottom: 2px solid #1890ff;
  }

  .littleTitleBox {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }

  .showwarning {
    color: red;
    padding-left: 200px;
    margin-bottom: 20px;
  }

  /deep/ #phone input {
    text-align: left !important;
  }

  .MerchantSettled_title {
    text-align: center;
    font-size: 28px;
    margin: 20px 0;
  }

  .MerchantSettled {
    background: #eff2f7;
  }
</style>